import type { FC } from "react";
import React, { Suspense } from "react";
import { CircularProgress } from "@material-ui/core";

import ErrorBoundary from "../../../../basic/error_boundary";
import { ProfileContainer } from "../profile_container/profile_container";

export const ProfileSuspense: FC = () => (
  <ErrorBoundary>
    <Suspense fallback={<CircularProgress />}>
      <ProfileContainer />
    </Suspense>
  </ErrorBoundary>
);
